/**
 * Конфигурация API endpoints
 * 
 * Development: использует относительный путь /api через Vite proxy
 * Production: использует полный URL из переменной окружения VITE_API_BASE_URL
 *             Если переменная не задана, используется /api (relative path)
 */

const isDevelopment = import.meta.env.DEV

const DEFAULT_API_BASE_URL = isDevelopment 
  ? '/api' // Относительный путь через прокси
  : (import.meta.env.VITE_API_BASE_URL ?? '/api') // Fallback на /api если переменная не задана

export const API_BASE_URL = stripTrailingSlash(DEFAULT_API_BASE_URL)

/**
 * Убирает trailing slash из URL
 */
function stripTrailingSlash(value: string): string {
  if (!value) {
    return value
  }

  return value.endsWith('/') ? value.slice(0, -1) : value
}
